import { io } from "socket.io-client";

export const socket = io("https://youtubersclan.com:40000", {
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,     
  reconnectionDelayMax: 5000,   
  timeout: 20000,       
  transports: ["websocket"]
});
export default socket;
